import ShopTwoIcon from "@mui/icons-material/ShopTwo";
import { FormattedMessage, useIntl } from "react-intl";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";
// icons

const useStaticPage = () => {
  const icons = {
    ShopTwoIcon,
    BusinessOutlinedIcon,
    WhereToVoteIcon,
  };

  // ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

  const packages = {
    id: "static-page",
    title: (
      <FormattedMessage id="Static Page">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    icon: icons.ShopTwoIcon,
    type: "group",
    // url: "/static-pages",
    children: [
      {
        id: "static-paget",
        title: <FormattedMessage id="Static Page" />,
        type: "item",
        url: "/static-pages",
        icon: icons.ShopTwoIcon,
        breadcrumbs: false,
      },
    ],
  };
  return packages;
};

export default useStaticPage;
